export const title = {
    en: "Help & Feedback",
    hi: "हेल्प  और फीडबैक",
    or: "ସାହାଯ୍ୟ ଏବଂ ମତାମତ",
}

export const subTitle = {
    en : "Please share your concerns or feedback with us.",
    hi: "कृपया अपनी चिंताएँ या फीडबैक हमारे साथ साझा करें।",
    or: "ଦୟାକରି ଆପଣଙ୍କ  ପ୍ରତିକ୍ରିୟା କିମ୍ବା ମତାମତ ଆମ ସହିତ ସେୟାର କରନ୍ତୁ।",
}

export const textPlaceholder = {
    en: "Type your feedback here",
    hi: "अपना फ़ीडबैक टाइप करें",
    or: "ଏଠାରେ ଆପଣଙ୍କର ପ୍ରତିକ୍ରିୟା ଟାଇପ୍ କରନ୍ତୁ"
}

export const submitLabel = {
    en: "Submit",
    hi: "जमा करें",
    or: "ଦାଖଲ କରନ୍ତୁ",
}